<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M4.5 1H2.5C1.67157 1 1 1.67157 1 2.5V4.5C1 5.32843 1.67157 6 2.5 6H4.5C5.32843 6 6 5.32843 6 4.5V2.5C6 1.67157 5.32843 1 4.5 1Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.5 1H11.5C10.6716 1 10 1.67157 10 2.5V4.5C10 5.32843 10.6716 6 11.5 6H13.5C14.3284 6 15 5.32843 15 4.5V2.5C15 1.67157 14.3284 1 13.5 1Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.5 10H2.5C1.67157 10 1 10.6716 1 11.5V13.5C1 14.3284 1.67157 15 2.5 15H4.5C5.32843 15 6 14.3284 6 13.5V11.5C6 10.6716 5.32843 10 4.5 10Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.5 10H11.5C10.6716 10 10 10.6716 10 11.5V13.5C10 14.3284 10.6716 15 11.5 15H13.5C14.3284 15 15 14.3284 15 13.5V11.5C15 10.6716 14.3284 10 13.5 10Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
